//this required to load css to the whole website (dynamic pages, and statis home).
require('./src/styles/styles.scss');